export default Object.freeze({
  PERCENT: 0,
})
